// extracted by mini-css-extract-plugin
module.exports =  {"btn":"Cw2eyFI","icon":"yZJqIrZ","open":"GKhtWmL"};